import { render, staticRenderFns } from "./wxproduct.vue?vue&type=template&id=79362285&scoped=true&"
import script from "./wxproduct.vue?vue&type=script&lang=js&"
export * from "./wxproduct.vue?vue&type=script&lang=js&"
import style0 from "./wxproduct.vue?vue&type=style&index=0&id=79362285&lang=scss&scoped=true&"
import style1 from "./wxproduct.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79362285",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79362285')) {
      api.createRecord('79362285', component.options)
    } else {
      api.reload('79362285', component.options)
    }
    module.hot.accept("./wxproduct.vue?vue&type=template&id=79362285&scoped=true&", function () {
      api.rerender('79362285', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxproduct.vue"
export default component.exports